export default "__VITE_ASSET__rjWsfAbr__"